import $ from 'jquery';
import './modal-vendor';

var Modal = function(modals) {
    this.modals = modals;
};

Modal.prototype._build = function() {
    return $('<div/>', { 'class': 'classic-modal__container' })
        .append($('<div/>', { 'class': 'classic-modal__overlay'}))
        .append($('<div/>', {
            'class': 'classic-modal__close-button',
            'data-modal-close': ''
        }))
        .append(
            $('<div/>', { 'class': 'classic-modal__inner' })
                .append($('<div/>', { 'class': 'classic-modal__liner'}))
        );
};

Modal.prototype.init = function(options, elem) {
    this.elem = elem;
    this.$elem = $(elem);

    this.options = options;
    this.name = options.name;
    this.halted = false;

    // Setup the overlay
    if ($('.classic-modal__overlay').length === 0) {

        this.$container = this._build();

        this.$container.on('click', '[data-modal-close]', function(e) {
            e.preventDefault();
            $('.classic-modal__container').data('modal').trigger('hide');
        }).find('.classic-modal__overlay').on('click', function(e) {
            // stop modal overlay clicked to close
            e.preventDefault();
            e.stopImmediatePropagation();
        });

        $('body').append(this.$container);
    }

    this.$trigger = $('[data-modal-name="' + this.name + '"]');
    this.$content = $(this.$trigger.data('modal-content'));


    // Dedupe events when multiple triggers bind ot the same content
    if (this.$content.selector in this.modals === false) {
        this.modals[this.$content.selector] = this.$content.omniWindow(
            $.extend({}, this.options, this.$trigger.data())
        );
    }

    this._bindEvents(this.options, this.$elem);

    this.modal = this.modals[this.$content.selector];
    this.$content.data('modal', this);

    return this;
};

Modal.prototype._bindEvents = function() {
    var that = this;

    // Attach a handler for triggering the modal
    $('body').on('click', that.$trigger.selector, function(e) {
        e.preventDefault();
        that.show();
    });
};

Modal.prototype.show = function() {
    $('.classic-modal__container').data('modal', this.modal);
    this.modal.trigger('show');
    return this;
};

Modal.prototype.hide = function() {
    $('.classic-modal__container').data('modal', null);
    this.modal.trigger('hide');
    return this;
};

Modal.prototype.stop = function() {
    this.halted = true;
    return this;
};

Modal.prototype.proceed = function() {
    this.halted = false;
    return this;
};

Modal.prototype.closeable = function(canClose) {
    $('.classic-modal__container').attr('data-modal-closeable', canClose);
    return this;
};

Modal.prototype.canProceed = function() {
    return !this.halted;
};

Modal.prototype.getName = function() {
    return this.name;
};

Modal.prototype.getContent = function() {
    return this.$content;
};

Modal.prototype.getTrigger = function() {
    return this.$trigger;
};

export default Modal;



// WEBPACK FOOTER //
// ./~/@99designs/asimov/modal/lib/modal-lib.js